<!-- src/components/ParkingBusinessList.vue -->
<template>
  <div class="parking-business-list">
    <h2 class='section-title'>停車場開發與經營業務</h2>
    <div class="business-grid">
      <div class="business-item" v-for="(item, index) in businessItems" :key="index">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParkingBusinessList',
  data() {
    return {
      businessItems: [
        '投資購地與興建停車場（塔）',
        '整場承租、對外經營（計時、月租、折扣點券、特約停車）',
        '租售並行（聯通承租經營停車場並配合車位主出售車位）',
        '大樓附建停車塔之投資興建、買賣合作經營',
        '停車位（場）投資買賣',
        '公有停車場委託經營',
        '公有地獎勵民間投資興建停車場（B.O.T）'
      ]
    }
  }
}
</script>

<style scoped>
.parking-business-list {

  width:1416px;

  margin: 0 auto;
}



.business-grid {
  display: grid;
  grid-template-columns: repeat(2, 696px); /* 2列，每列696px */
  gap: 24px;                              /* 行间距和列间距均为20px */
  max-width: calc(2 * 696px + 20px);      /* 2列696px + 1个间距20px = 1412px */
  margin: 0 auto;
}

.business-item {
  background-color: #ffffff;             /* 卡片背景改为白色 */
  /* 取消边框线 */
  border: none;                            /* 明确取消边框 */
  color: var(--green03);            /* 文字颜色改为主绿色 */


  display: flex;
  align-items: center;
  justify-content: center;
  width: 696px; /* 固定宽度 */
  height: 96px; /* 固定高度 */
  box-sizing: border-box;
  border-radius: 20px;

  /* //styleName: xl/bold; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;




}



@media (max-width: 560px) {

  .parking-business-list {
    width: 343px; /* 调整宽度 */
  }

  .business-grid {
    grid-template-columns: 343px; /* 1列，每列343px */
    max-width: 343px;             /* 1列343px */

    gap: 12px;                    /* 调整行间距和列间距 */
  }

  .business-item {
    width: 343px; /* 调整宽度 */
    height: 64px; /* 调整高度 */
    font-size: 1em; /* 根据需要调整字体大小 */
  }

}
</style>
